/**
 * Desgins Queries
 */
import { graphql } from 'react-apollo'
import gql from 'graphql-tag'

export const getSingleTeamStore = gql`
  query getTeamStore(
    $teamStoreId: String!
    $passCode: String
    $date: HolyDate
    $limit: Int
    $offset: Int
    $categoryId: Int
    $shortIdCategory: String
  ) {
    getTeamStore(
      teamStoreId: $teamStoreId
      passCode: $passCode
      storeFront: true
      date: $date
      limit: $limit
      offset: $offset
      isInfinite: true
      categoryId: $categoryId
      shortIdCategory: $shortIdCategory
    ) {
      id
      short_id
      name
      banner
      private
      passCodeRaw: passcode_raw
      bulletin
      backgroundImageBanner: background_image_banner
      backgroundColorBanner: background_color_banner
      cssStyleBanner: css_style_banner
      richTextBanner: rich_text_banner
      isResellerStore
      owner
      from_ca
      owner_name
      display
      fixedPrice: fixed_price
      onDemandMode: on_demand_mode
      team_size_id
      closed
      gracePeriod: grace_period
      reminders
      couponReminder: coupon_reminder
      accountManager {
        short_id
      }
      priceRanges {
        id
        name: quantity_description
      }
      cutoff_date {
        day
        dayOrdinal
        month
      }
      delivery_date {
        day
        dayOrdinal
        month
      }
      items(categoryId: $categoryId) {
        id
        expected_quantity
        visible
        short_id
        isInline: is_inline
        priceRange {
          price
          shortName: short_name
          quantity
          abbreviation
        }
        resellerRange {
          price
          shortName: short_name
          quantity
          abbreviation
        }
        design {
          id
          code
          name
          image
          shortId: short_id
          proDesign: pro_design
          proCertified: pro_certified
          product {
            id
            code
            yotpoId: yotpo_id
            name
            active
            hasSizeRecEnabled: has_size_rec_enabled
            type: name
            customizable: design_center
            designCenter: design_center
            onlyProDesign: only_pro_design
            description: short_description
            hideFitStyles: hide_fit_styles
            sizeTag: size_tag
            youthCombined: youth_combined
            shortDescription: short_description
            colorGenders: color_genders
            hasInventory: has_inventory
            inventoryJson: inventory_json
            fitPreferences: fit_preferences
            isTopProduct
            weight
            twoPieces: two_pieces
            genders {
              id
              name: gender
            }
            colors {
              id
              name
              image
            }
            fitStyles {
              id
              info
              name: description
            }
            priceRange {
              quantity
              price
              abbreviation
              shortName: short_name
            }
            sizeRange: size_range {
              id
              name
              isYouth: is_youth
            }
            images: pictures {
              front: front_image
              back: back_image
              left: left_image
              right: right_image
              thumbnail
              preview
              default_preview   
              color_id
            }
          }
        }
        totalOrders
      }
      totalDesigns(categoryId: $categoryId)
    }
  }
`

export const getTotalProductCategories = gql`
  query getTotalProductCategories($teamStoreId: Int!) {
    categoryIds: getTotalProductCategories(teamStoreId: $teamStoreId) {
      category_1
      category_2
      category_3
      category_4
      category_5
      category_6
      category_7
      category_8
      category_9
      category_10
      category_11
      category_13
    }
  }
`

export const profileSettingsQuery = gql`
  query profile {
    profileData: getUserProfile {
      userProfile {
        phone
        country_code
      }
      reseller {
        status
        currency
        comission
        inline
        paypalAccount: paypal_account
        displayDynamicBatch: display_dynamic_batch
        displayFixedBatch: display_fixed_batch
      }
    }
  }
`

/* TODO: are needed these fields?
  priceRanges {
    id
    name: quantity_description
    abbreviation
    shortName: short_name
  }
*/

export const changeStorePasswordMutation = graphql(
  gql`
    mutation changeStorePassword($id: Int!, $passCode: String!) {
      privateTeamStore: changeStorePassword(id: $id, passCode: $passCode) {
        message
      }
    }
  `,
  {
    name: 'changeStorePassword'
  }
)

export const changeStoreRemindersMutation = graphql(
  gql`
    mutation changeStoreReminders($id: Int!, $reminderEmail: String!, $reminderPhone: String) {
      store: changeStoreReminders(id: $id, reminderEmail: $reminderEmail, reminderPhone: $reminderPhone) {
        message
      }
    }
  `,
  {
    name: 'changeStoreReminders'
  }
)

export const removeStoreReminderMutation = graphql(
  gql`
    mutation removeStoreReminder($id: Int!, $reminderEmail: String!) {
      store: removeStoreReminder(id: $id, reminderEmail: $reminderEmail) {
        message
      }
    }
  `,
  {
    name: 'removeStoreReminder'
  }
)


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/StoreFrontContent/data.ts